module.exports = __webpack_public_path__ + "img/eSIM-Active-Light.e3977e9.svg";